const formatDecimal2Digits = (value: string) => {
  return value
    .replace(/[^0-9,.]+/g, "")
    .replace(/\.|\.,|,,|,\./g, ",")
    .replace(/,(\d{2})\d+/g, ",$1");
};

export default formatDecimal2Digits;
